export const getAlbums = () => {
  return fetch('https://ws.audioscrobbler.com/2.0/?method=user.gettopalbums&user=josephtatum&period=1month&limit=10&api_key=b25ee16830a87e81d1b3a0c98375d811&format=json')
    .then(res => res.json());
};
